document.addEventListener('alpine:init', () => {
	try {
		Alpine.plugin(focus)
		Alpine.data('mixAndMatch', () => ({
			selectedCategory: '',
			selectedProducts: [],
			currentDate: Date.now(),
			currentOption: {},
			nextOption: {},
			numberOfProducts: 0,
			nextTierQuantity: 0,
			numberOfProductsToNextTier: 0,
			nextTierDiscount: 0,
			totalPrice: 0,
			totalCompareAtPrice: 0,
			identifier: '',
			hasDiscountOptions: false,
			bundleConfig: window.foxsell?.bundleConfig || {
				options: [],
				categories: []
			},

			init() {
				if (!window.foxsell || !window.foxsell.bundleConfig) {
					return
				}
				if (window.foxsell.bundleConfig.categories.length > 0) {
					this.selectedCategory = window.foxsell.bundleConfig.categories[0].title.toLowerCase()
				}

				// Handle empty options: create a default option from category/product data
				if (this.bundleConfig.options.length === 0) {
					const requiredQuantity = this.bundleConfig.categories.reduce(
						(sum, cat) => sum + (cat.quantity || 0), 0
					) || 1
					this.bundleConfig.options = [{
						quantity: requiredQuantity,
						price: { value: 0 },
						variant_id: String(this.bundleConfig.product.variants[0].id),
						add_on: { minimum: 0 }
					}]
					this.hasDiscountOptions = false
				} else {
					this.hasDiscountOptions = this.bundleConfig.options.some(option => option.price && option.price.value > 0)
				}

				this.getNextTierQuantity()
				this.getNextTierDiscount()

				this.selectedProducts = []

				this.nextOption = this.bundleConfig.options[1] || this.bundleConfig.options[0]

				this.currentOption = this.bundleConfig.options[0]

				this.identifier = `${this.bundleConfig.id}_${this.currentDate}`

				this.$nextTick(() => {
					this.updateHeaderOffset()
					window.addEventListener('resize', () => this.updateHeaderOffset())
				})
				window.addEventListener('scroll', () => this.updateSelectedCategoryOnScroll())

				this.recalculateProductPrices()
			},

			updateSelectedCategoryOnScroll() {
				const categoryElements = document.querySelectorAll('[data-category-section]')
				const scrollPosition = window.scrollY + window.innerHeight / 2

				for (const element of categoryElements) {
					const rect = element.getBoundingClientRect()
					const absoluteTop = window.scrollY + rect.top

					if (scrollPosition > absoluteTop) {
						const category = element.getAttribute('data-category-section').toLowerCase()
						if (this.selectedCategory !== category) {
							this.selectedCategory = category
							// La classe `.selected` est posée par Alpine : on attend le tick
							// suivant pour lire la position du bon onglet.
							this.$nextTick(() => this.scrollActiveTabIntoView())
						}
					}
				}
			},

			// La barre d'onglets défile horizontalement sur mobile : sans ça l'onglet
			// actif sort du champ dès qu'on descend dans les dernières catégories.
			scrollActiveTabIntoView() {
				const bar = document.querySelector('.mix-and-match__header')
				const active = bar && bar.querySelector('a.selected')
				if (!bar || !active || bar.scrollWidth <= bar.clientWidth) return

				const offset = active.offsetLeft - (bar.clientWidth - active.offsetWidth) / 2
				bar.scrollTo({ left: Math.max(offset, 0), behavior: 'smooth' })
			},

			getNextTierQuantity() {
				this.refreshCurrentOption()
				if (!this.hasDiscountOptions) {
					const minProducts = this.bundleConfig.addonMinProducts || 0
					this.nextTierQuantity = minProducts
					this.numberOfProductsToNextTier = minProducts - this.getTotalQuantity('product')
				} else {
					this.nextTierQuantity = this.nextOption.quantity
					this.numberOfProductsToNextTier = this.nextTierQuantity - this.getTotalQuantity('product')
				}

				if (this.numberOfProductsToNextTier < 0) {
					this.numberOfProductsToNextTier = 0
				}
				return this.numberOfProductsToNextTier
			},

			getNextTierDiscount() {
				if (this.nextOption && this.nextOption.price) {
					this.nextTierDiscount = '-' + this.nextOption.price.value + '%'
				} else {
					this.nextTierDiscount = ''
				}
				return this.nextTierDiscount
			},

			getTotalQuantity(type = null) {
				this.numberOfProducts = this.selectedProducts
					.filter(product => (type ? product.type === type : product.type !== 'addOns'))
					.reduce((total, product) => total + (product.quantity || 1), 0)
				return this.numberOfProducts
			},

			createBundleLineItemProperties() {
				return this.selectedProducts.map(product => ({
					variantId: product.variantId,
					quantity: product.quantity,
					type: product.type,
					...(product.type === 'product' ? { category: product.category } : { properties: product.properties })
				}))
			},

			checkIfPrimaryAddToCartButtonIsVisible() {
				this.refreshCurrentOption()
				const totalQuantity = this.getTotalQuantity('product')
				const totalQuantityAddOns = this.getTotalQuantity('addOns')

				if (!this.hasDiscountOptions) {
					const minProducts = this.bundleConfig.addonMinProducts || 0
					return totalQuantity >= minProducts
				}

				if (this.currentOption.quantity === totalQuantity) return true

				const lastOption = this.bundleConfig.options[this.bundleConfig.options.length - 1]

				if (this.currentOption.quantity === lastOption.quantity) {
					if (totalQuantity >= this.currentOption.quantity && this.currentOption.quantity + 5 >= totalQuantity) {
						return true
					}
					return false
				}

				const {
					quantity: quantityMin,
					add_on: { minimum: quantityMinAddOn }
				} = this.nextOption

				return totalQuantity >= quantityMin && totalQuantityAddOns >= quantityMinAddOn
			},

			checkLimitQuantity() {
				const totalQuantity = this.getTotalQuantity('product')
				const totalQuantityAddOns = this.getTotalQuantity('addOns')
				const quantityMin = this.nextOption.quantity
				const quantityMinAddOn = this.nextOption.add_on.minimum

				if (totalQuantity < quantityMin) {
					return false
				}
				if (totalQuantityAddOns < quantityMinAddOn) {
					return false
				}
				return true
			},

			checkIfProductsAddToCartButtonIsVisible() {
				this.refreshCurrentOption()
				const totalQuantity = this.getTotalQuantity('product')

				if (!this.hasDiscountOptions) {
					const maxQuantity = this.bundleConfig.options[this.bundleConfig.options.length - 1].quantity
					return totalQuantity >= maxQuantity
				}

				if (this.currentOption.quantity === totalQuantity) {
					return true
				}

				return false
			},

			refreshCurrentOption() {
				this.nextOption = this.bundleConfig.options.find(option => option.quantity > this.getTotalQuantity('product'))
				if (!this.nextOption) {
					this.nextOption = this.bundleConfig.options[this.bundleConfig.options.length - 1]
				}

				const totalQuantity = this.getTotalQuantity('product')
				this.currentOption = this.bundleConfig.options.filter(option => option.quantity <= totalQuantity).sort((a, b) => b.quantity - a.quantity)[0]

				if (!this.currentOption) {
					this.currentOption = this.bundleConfig.options[0]
				}
			},

			refreshCurrentDate() {
				this.currentDate = Date.now()
			},

			async addToCart() {
				this.refreshCurrentOption()
				const totalPrice = this.getTotalPrice()

				const productProperties = {}
				this.selectedProducts.forEach(product => {
					productProperties[product.title] = `x${product.quantity}`
				})

				const response = await fetch('/cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						items: [
							{
								id: this.currentOption.variant_id,
								quantity: 1,
								properties: {
									...productProperties,
									'__foxsell:original_bundle_price': totalPrice,
									'__foxsell:dynamic_add_on_bundle_id': `${this.bundleConfig.id}_${Date.now()}`,
									'__foxsell:dynamic_add_on_bundle_items': JSON.stringify(this.createBundleLineItemProperties())
								}
							}
						]
					})
				})
				const data = await response.json()
				this.date = Date.now()

				window.monster_refresh()
				this.refreshCurrentDate()
				this.init()
			},

			meetsQuantityRequirement(requiredQuantity) {
				const totalQuantity = this.getTotalQuantity('product')
				return totalQuantity >= requiredQuantity
			},

			updateHeaderOffset() {
				// `.pmp-header-section` est le wrapper de la section header-megamenu, qui porte
				// le sticky. `.header-wrapper` reste en repli pour l'ancien header Dawn.
				const header =
					document.querySelector('.pmp-header-section') ||
					document.querySelector('.header-wrapper') ||
					document.querySelector('header')
				if (header) {
					const headerHeight = header.offsetHeight
					document.documentElement.style.setProperty('--header-height', `${headerHeight}px`)
				}
			},

			roundPrice(price) {
				return Math.round(price * 100) / 100
			},

			formatPrice(price) {
				return `${price}€`
			},

			getCurrentDiscount() {
				this.refreshCurrentOption()
				let discount = 0

				let totalQuantity = this.getTotalQuantity('product')
				if (this.currentOption && this.currentOption.price && totalQuantity >= this.currentOption.quantity) {
					discount = this.currentOption.price.value
				}
				return discount
			},

			getTotalPrice() {
				return this.roundPrice(this.selectedProducts.reduce((total, product) => total + this.getProductPrice(product), 0))
			},

			getTotalCompareAtPrice() {
				return this.roundPrice(this.selectedProducts.reduce((total, product) => total + this.getProductCompareAtPrice(product), 0))
			},

			getProductPrice(product) {
				const basePrice = product.price / 100
				const discount = this.getCurrentDiscount() / 100
				const finalPrice = basePrice * (1 - discount) * product.quantity
				return this.roundPrice(finalPrice)
			},

			getProductCompareAtPrice(product) {
				const basePrice = product.compare_at_price || product.price
				const priceInEuros = basePrice / 100
				return this.roundPrice(priceInEuros * product.quantity)
			},

			addProduct(product, variantId, image, category) {
				if (this.selectedProducts.find(p => p.id === product.id)) {
					this.updateProductQuantity(product.id, 1)
					return
				}

				this.selectedProducts.push({
					...product,
					variantId: variantId,
					image: image,
					quantity: 1,
					category: category,
					type: 'product'
				})
				this.syncAddOn()
				this.recalculateProductPrices()
				this.getTotalQuantity()
				this.getNextTierQuantity()
				this.getNextTierDiscount()
			},

			removeProduct(productId) {
				this.selectedProducts = this.selectedProducts.filter(p => p.id !== productId)
			},

			recalculateProductPrices() {
				this.selectedProducts = this.selectedProducts.map(product => ({
					...product,
					price_with_discount: this.formatPrice(this.getProductPrice(product)),
					compared_price_with_discount: this.formatPrice(this.getProductCompareAtPrice(product))
				}))

				this.totalPrice = this.formatPrice(this.getTotalPrice())
				this.totalCompareAtPrice = this.formatPrice(this.getTotalCompareAtPrice())
			},

			updateProductQuantity(productId, quantity) {
				// find product in selectedProducts
				let currentProduct = this.selectedProducts.find(p => p.id === productId)
				if (!currentProduct) {
					return
				}
				const newQuantity = currentProduct.quantity + quantity
				if (newQuantity <= 0) {
					this.removeProduct(productId)
				} else {
					currentProduct.quantity = newQuantity
				}
				this.syncAddOn()
				this.recalculateProductPrices()
				this.getTotalQuantity()
				this.getNextTierQuantity()
				this.getNextTierDiscount()
			},

			syncAddOn() {
				const minProducts = this.bundleConfig.addonMinProducts || 0
				const productCount = this.getTotalQuantity('product')
				const hasAddOn = this.selectedProducts.some(p => p.type === 'addOns')
				const addOnProducts = window.foxsell?.bundleConfig?.addOnProducts

				if (productCount >= minProducts && !hasAddOn && addOnProducts && addOnProducts.length > 0) {
					const addOn = addOnProducts[0]
					const addOnId = String(addOn.id)
					const variantId = addOn.variants[0].id
					const bundlePrice = this.bundleConfig.addOnProductProperties?.[addOnId]?.variants?.[String(variantId)]

					this.selectedProducts.push({
						...addOn,
						price: bundlePrice != null ? bundlePrice * 100 : addOn.price,
						quantity: 1,
						type: 'addOns',
						properties: {},
						variantId: variantId
					})
				} else if (productCount < minProducts && hasAddOn) {
					this.selectedProducts = this.selectedProducts.filter(p => p.type !== 'addOns')
				}
			},

			shouldShowPrices() {
				return this.totalPrice !== '0€' && this.selectedProducts.length > 0
			}
		}))
	} catch (error) {
		console.error('Error initializing mixAndMatch component:', error)
	}
})
